import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function TextAlign({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={""}>
          Default
        </MenuItem>,
        (["start", "end", "center", "justify"] as const).map((alignment) => (
          <MenuItem key={alignment} value={alignment}>
            <span style={{ textAlign: alignment }}>{alignment}</span>
          </MenuItem>
        )),
      ]}
      rules={{ required }}
    />
  );
}

export const JSTextAlignComponent: JSInputComponent = {
  Component: TextAlign,
  handlesCssProperties: ["textAlign"],
};
